import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const services = [
  { titleKey: 'service_1_title', descKey: 'service_1_desc', img: 'service_1_img', icon: 'ri-home-4-line' },
  { titleKey: 'service_2_title', descKey: 'service_2_desc', img: 'service_2_img', icon: 'ri-home-5-line' },
  { titleKey: 'service_3_title', descKey: 'service_3_desc', img: 'service_3_img', icon: 'ri-fire-line' },
  { titleKey: 'service_4_title', descKey: 'service_4_desc', img: 'service_4_img', icon: 'ri-error-warning-line' },
];

export default function ServicesHiver() {
  const { t } = useTranslation('deneigement');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="services" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('services_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-6">
          {services.map((service, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl overflow-hidden transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="h-48 md:h-52 overflow-hidden">
                <img
                  src={t(service.img)}
                  alt={t(service.titleKey)}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-blue-ice/10">
                    <i className={`${service.icon} text-blue-ice`} />
                  </div>
                  <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base">
                    {t(service.titleKey)}
                  </h3>
                </div>
                <p className="text-slate-primary/60 text-xs md:text-sm leading-relaxed">
                  {t(service.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}